import { render, staticRenderFns } from "./GpgPublicKeys.vue?vue&type=template&id=0b11a794"
import script from "./GpgPublicKeys.vue?vue&type=script&lang=ts"
export * from "./GpgPublicKeys.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports